import { useContext } from 'react';

import { GlobalPropsContext } from 'lib/app/global-props-provider';

export const useGlobalProps = () => {
    return useContext(GlobalPropsContext);
};
